/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-08 16:09:24
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-08 16:15:04
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Line/types.ts
 */
import type { LineBasicMaterialParameters, LineDashedMaterialParameters } from '@anov/3d-core'

export type options = {
  points: [number, number, number][]
  dashed?: boolean
  material?: LineBasicMaterialParameters | LineDashedMaterialParameters
}